<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb" title="dacGeneralParams.title"> </sm-page-header>
    <!-- content -->
    <div class="content">
        <div class="flex justify-end mb-2">
            <button pButton type="button" icon="pi pi-file-excel" [label]="'dacGeneralParams.export' | translate"
                [loading]="(exporting | async) || false" (click)="exportToExcel()"></button>
        </div>
        <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="(loading | async)"
            [totalRecords]="totalRecords"></sm-data-table-builder>
    </div>
</div>